export default __webpack_public_path__ + "static/media/transaction.1cbf639f.png";